// extracted by css-extract-rspack-plugin
export default {"cls1":"PodcastLibraryCarouselAd-cls1_WRC","cls2":"PodcastLibraryCarouselAd-cls2_cTn PodcastLibraryCarouselAd-cls1_WRC"};